import { render, staticRenderFns } from "./follow_sign.vue?vue&type=template&id=558bfa94&scoped=true&"
import script from "./follow_sign.vue?vue&type=script&lang=js&"
export * from "./follow_sign.vue?vue&type=script&lang=js&"
import style0 from "./follow_sign.vue?vue&type=style&index=0&id=558bfa94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558bfa94",
  null
  
)

export default component.exports